const newCreditCardDialogStyles = theme => ({
  root: {
    width: '100%',
    padding: theme.spacing.unit * 3
  }
});

export default newCreditCardDialogStyles;
